import { render, staticRenderFns } from "./apphistory.vue?vue&type=template&id=0016ec2f&"
import script from "./apphistory.vue?vue&type=script&lang=js&"
export * from "./apphistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0016ec2f', component.options)
    } else {
      api.reload('0016ec2f', component.options)
    }
    module.hot.accept("./apphistory.vue?vue&type=template&id=0016ec2f&", function () {
      api.rerender('0016ec2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apphistory/apphistory.vue"
export default component.exports